import { render, staticRenderFns } from "./AddBusinessForm.vue?vue&type=template&id=18223244&scoped=true"
import script from "./AddBusinessForm.vue?vue&type=script&lang=js"
export * from "./AddBusinessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18223244",
  null
  
)

export default component.exports